import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalDialog from '@stone/components/modal/ModalDialog';
import Button from '@stone/ui/button/Button';
const ConfirmCountryModal = (props) => {
    const { t } = useTranslation();
    const { onFeeback } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalDialog, { isOpen: props.open, onRequestClose: () => {
                onFeeback(false);
            }, overlayClassName: "mobile-visible", contentLabel: t('checkout.shipping.selectlocation'), className: "confirmation-country-modal" },
            React.createElement("div", { className: "row countryselector-modal" },
                React.createElement("div", { className: 'col-24' },
                    React.createElement("p", { className: "countryselector-modal__description" }, t('checkout.shipping.changecountrydescription')))),
            React.createElement("div", { className: "divider divider--small" }),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24" },
                    React.createElement("p", { className: "countryselector-modal__description" }, t('checkout.shipping.changecountryproceed'))),
                React.createElement("div", { className: "col-lg-12 col-24 mt-20" },
                    React.createElement(Button, { type: "button", cls: ['button--secondary'], className: "full", onClick: () => {
                            onFeeback(false);
                        } }, t('label.no'))),
                React.createElement("div", { className: "col-lg-12 col-24 mt-20" },
                    React.createElement(Button, { type: "button", cls: ['button--primary'], className: "full", onClick: () => {
                            onFeeback(true);
                        } }, t('label.yes')))))));
};
export default ConfirmCountryModal;
